export const mergeNonUndefined = <T>(
  prevData: T,
  newData: Partial<T>,
): T => ({
    ...prevData,
    ...Object.fromEntries(
      Object.entries(newData).filter(([, value]) => (
        value !== undefined
          && value !== null
          && (typeof value !== 'string' || value.trim() !== '')
      )),
    ),
  });
